export const TOP_PADDING = 9;
export const FULL_SCREEN_PADDING = 7;

export const HEADER_HEIGHT = 44;
